import { render, staticRenderFns } from "./opcHeader.vue?vue&type=template&id=7af2be54&scoped=true"
import script from "./opcHeader.vue?vue&type=script&lang=js"
export * from "./opcHeader.vue?vue&type=script&lang=js"
import style0 from "./opcHeader.vue?vue&type=style&index=0&id=7af2be54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af2be54",
  null
  
)

export default component.exports